<template>
  <div class="cube-query">
    <div class="J-select-cube">
      <div class="guid-tip-container">
        <div class="select">
          <div class="input" :class="{ 'select-open': isOpen }">
            <span class="J-current" :title="getSelectName">{{ getSelectName }}</span>
            <el-dropdown @command="previewDetail" :disabled="isDown">
              <el-tooltip :disabled="!isDown" placement="left">
                <div slot="content" style="width: 100px;color: #fff;">此指标已下架</div>
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
              </el-tooltip>
              <el-dropdown-menu class="jzliu-bi-engine-cube-query-dropdown-menu" slot="dropdown">
                <el-dropdown-item command="previewDetail">预览明细数据</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="dropdown-menu" v-if="isOpen">
            <div class="dropdown-position-wrapper">
              <div class="dropdown-menu-data">
                <!--                todo-->
                <!--                  <div class="cube-box"></div>-->
                <!--                  <div class="dropdown-box-title"></div>-->
                <!--                  <div class="ui-schema-antd-input-affix-wrapper"></div>-->
                <div class="cube-file-tree">
                  <ul class="ui-schema-antd-tree">
                    <li :class="{ 'active-li': i.id === value }" @click="selectClick(i)" v-for="i in list">
                      {{ i.label }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="dropdown-menu-oper"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mockGetFactInfos } from '../mock/factInfos'
export default {
  name: 'cubeQuery',
  props: {
    value: [String, Number],
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isOpen: false,
      list: [],
    }
  },
  computed: {
    isDown() {
      return this.selectItem.status === '-1'
    },
    getSelectName() {
      // const cur = this.list.filter((v) => v.id === this.value)[0]
      // if (this.value) {
      //   this.$emit('change', this.value)
      // }
      return this.selectItem.dataSetName ?? '请选择数据集'
    },
  },
  created() {
    this.getFactInfos()
  },
  methods: {
    async getFactInfos() {
      const { data } = await mockGetFactInfos()
      this.list = (data ?? []).map((v) => {
        return {
          ...v,
          id: v.factCode,
          label: v.factName,
        }
      })
    },
    openHandler(flag) {
      this.isOpen = flag
    },
    previewDetail(command) {
      if(this.isDown) {
        return
      }
      if (command === 'previewDetail') {
        this.$emit('preview-detail', this.selectItem)
      }
    },
    selectClick(select) {
      const id = select.id
      this.selectItem.dataSetId = id
      this.selectItem.dataSetName = select.label
      this.$emit('input', id)
      this.$emit('change', id)
      this.openMenuClick(false)
    },
    openMenuClick() {
      return
      this.openHandler(!this.isOpen)
    },
  },
}
</script>

<style lang="less">
.jzliu-bi-engine-cube-query-dropdown-menu {
  width: 150px;
}
</style>

<style scoped lang="less">
.cube-query {
  position: relative;
  z-index: 11;
  padding: 8px;

  .J-select-cube {
    display: flex;

    .guid-tip-container {
      position: relative;
      display: block;
      line-height: 1.5;
      flex: 1;

      .select {
        flex: 1;
        position: relative;
        height: 24px;

        .input {
          display: flex;
          align-items: center;
          width: 100%;
          height: 24px;
          line-height: 24px;
          border-radius: 2px;
          padding: 0 10px;
          position: absolute;
          right: 0;
          top: 0;
          color: var(--bi-jz-font-color);
          transition: width 0.2s linear;
          background-color: #f7f7f7;
          font-size: 12px;

          i {
            transition: 0.3s all;
            font-size: 14px;
            color: var(--bi-jz-font-color);
          }

          .J-current {
            user-select: none;
            display: block;
            flex-grow: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .select-open {
          width: 320px;

          .el-icon-caret-bottom {
            transform: rotate(180deg);
          }
        }

        .dropdown-menu {
          width: 320px;
          overflow-y: hidden;
          min-height: 60px;
          max-height: 480px;
          border-top: none;
          position: absolute;
          top: 100%;
          right: 0;
          z-index: 1000;
          background-color: #081226;
          background-clip: padding-box;
          border-bottom-left-radius: 2px;
          border-bottom-right-radius: 2px;

          .dropdown-position-wrapper {
            margin-bottom: 44px;
            height: 100%;
            position: relative;
            max-height: 440px;
            overflow-y: auto;

            .cube-box {
              color: var(--bi-jz-font-color);
              border-bottom: 1px solid var(--bi-jz-border-color);
            }

            .dropdown-box-title {
              color: var(--bi-jz-font-color);
              display: flex;
              justify-content: space-between;
              padding: 10px;
              cursor: pointer;
            }

            .ui-schema-antd-input-affix-wrapper {
              padding: 0 8px;
              position: relative;
              box-sizing: border-box;
              margin: 0 0 4px 0;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              font-variant: tabular-nums;
              line-height: 1.5;
              list-style: none;
              font-feature-settings: 'tnum';
              display: inline-block;
              width: 100%;
              text-align: start;
            }

            .cube-file-tree {
              padding: 0 10px;
              overflow-x: hidden;

              .ui-schema-antd-tree {
                padding: 8px 0;

                .active-li {
                  background: #2e74ff;
                }

                li {
                  transition: 0.3s all;
                  padding: 2px;
                  font-size: 12px;
                  color: hsla(0, 0%, 100%, 0.85);

                  &:hover {
                    background-color: hsla(0, 0%, 100%, 0.3);
                  }
                }
              }
            }
          }

          .dropdown-menu-oper {
            padding: 8px;
            display: flex;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
